import { Box, BoxProps } from '@material-ui/core'
import { useAnalytics } from 'hooks/use-analytics/useAnalytics'
import { FunctionComponent } from 'react'
import styled from 'styled-components/macro'

const StyledTab = styled(Box)<{ backgroundColor?: string, radius?: string }>`
  display: flex;
  justify-content: space-evenly;
  border-radius: ${props => props.radius ? props.radius : '20px'};
  background: ${props => props.backgroundColor || props.theme.colors.supplementary};
`

const StyledTitle = styled(Box)<{
  index: number
  active: number
  backgroundColor?: string
  padding?: string
  color?: string
  tabColor?: string
  summitFontSize?: boolean
  radius?: string
  fontFamily?: string
  activeFont?: string
}>`
  width: 100%;
  text-align: center;
  cursor: pointer;
  border-radius: ${props => props.radius ? props.radius : '20px'};
  padding: ${props => props.padding || '5px'};
  background: ${props =>
  props.index === props.active ? props.tabColor || props.theme.colors.primary : props.backgroundColor};
  font-weight: bold;
  color: ${props => props.index === props.active ? props.theme.colors.accent1 : props.color || props.theme.colors.accent} !important;
  font-size: ${props => (props.summitFontSize ? '1.3em' : 'unset')};
  font-family: ${props => props.fontFamily ? props.fontFamily : 'unset'};
`
interface BubbleTabsProps extends BoxProps {
  tabs: string[]
  activeTab: number
  setActiveTab: Function
  backgroundColor?: string
  padding?: string
  color?: string
  tabColor?: string
  summitFontSize?: boolean
  setShowConfirmEmail?: Function
  view?: string
  radius?: string
  fontFamily?: string
  activeFont?: string
}
export const BubbleTabs: FunctionComponent<BubbleTabsProps> = ({
  tabs,
  activeTab,
  setActiveTab,
  backgroundColor,
  padding,
  tabColor,
  color,
  summitFontSize,
  setShowConfirmEmail,
  view='event',
  radius,
  fontFamily,
  activeFont,
  ...props
}) => {
  const { logEventAnalytics } = useAnalytics()
  return (
    <Box {...props}>
      <StyledTab backgroundColor={backgroundColor} radius={radius}>
        {tabs?.map((tab, index) => (
          <StyledTitle
            key={index}
            onClick={() => {
              setActiveTab(index)
              if (setShowConfirmEmail) setShowConfirmEmail(false)
              if (view ==='sign-up' && index == 1) {
                logEventAnalytics('User','sign up clicked','mixpanel')
              }
            }}
            index={index}
            active={activeTab}
            backgroundColor={backgroundColor}
            padding={padding}
            color={color}
            tabColor={tabColor}
            summitFontSize={summitFontSize}
            radius={radius}
            fontFamily={fontFamily}
            activeFont={activeFont}
          >
            {tab}
          </StyledTitle>
        ))}
      </StyledTab>
    </Box>
  )
}
